export default __webpack_public_path__ + "static/media/City-driver-pana.205f302d.png";